import { AppRoute } from '@app/core/routing/AppRoute';
import { LoggerStatusPage } from '@app/modules/logger/screens/status/LoggerStatusPage';
import { Redirect, Switch } from 'react-router-dom';
import { LoggerStreamAdapterPage } from './LoggerStreamAdapterPage';

export default function LoggerRoutes() {
  return (
    <Switch>
      <AppRoute path="/logger/status" component={LoggerStatusPage} />
      <AppRoute path="/logger/s/:slug" component={LoggerStreamAdapterPage} />

      {/* old routes compatibility */}
      <Redirect exact path="/logger/station/:slug" to="/logger/s/:slug" />

      {/* catch all */}
      <Redirect to="/logger/status" />
    </Switch>
  );
}
